export const createRequestGate = ({ttlMs = 0} = {}) => {
  const inFlight = new Map();
  const cache = new Map();

  const gate = async ({key, fetcher, bypassCache = false}) => {
    if (!bypassCache) {
      const cacheEntry = cache.get(key);
      if (ttlMs > 0 && cacheEntry && Date.now() - cacheEntry.ts < ttlMs) {
        return cacheEntry.value;
      }

      if (inFlight.has(key)) {
        return inFlight.get(key);
      }
    }

    const requestPromise = Promise.resolve().then(fetcher);
    if (!bypassCache) {
      inFlight.set(key, requestPromise);
    }

    try {
      const value = await requestPromise;
      if (!bypassCache && ttlMs > 0) {
        cache.set(key, {ts: Date.now(), value});
      }
      return value;
    } finally {
      if (!bypassCache) {
        inFlight.delete(key);
      }
    }
  };

  gate.clearCache = () => {
    cache.clear();
  };

  gate.clearAll = () => {
    inFlight.clear();
    cache.clear();
  };

  gate.deleteKey = (key) => {
    inFlight.delete(key);
    cache.delete(key);
  };

  return gate;
};
